// https://ember-intl.github.io/ember-intl/versions/v5.7.0/docs/guide/missing-translations#at-runtime
export default function missingMessage(key, locales) {
  let message = `Missing translation: '${key}' for locale '${locales}'`;

  if ('QUnit' in window) {
    window.QUnit.config.current.pushResult({
      result: false,
      message: `[ember-intl] ${message}`,
    });
  }

  return message;
}
